import TalentsAPI from '../Apis/TalentsAPI';
import toList from '../utils/ComponentUtil';
import Header from '../utils/Header';
import "./DailyJobsDesc.scss"
import "./PostTalent.scss"
import PostTalentCard from './PostTalentCard';

function PostTalent() {
   const talents = TalentsAPI.talentTypes;

    return (
        <div className="post-talents-wrp wrapper">
            <Header title='Post your Talent' subTitle='Post what work you can do at your Part time. Fix your Own Price and Time duration for your Work.'/>
            <div className="talents-container">
                {toList(talents, PostTalentCard)}
            </div>
        </div>
    );
}

export default PostTalent;